// CustomTooltipCat.js
import React from "react";

const severityLabels = {
  1: "Very Low",
  2: "Low",
  3: "Moderate",
  4: "High",
  // 5: "Very High",
};

const severityColors = {
  1: "#00a084", // Very Low - green
  2: "#608ce6ff", // Low - lighter green
  3: "#ffc40c", // Moderate - yellow
  4: "#dd1e47", // Very High - red
  // 5: "#ff9800",
};

export default function CustomTooltipCat({ active, payload, label }) {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: "#f5f5f5",
          border: "1px solid #ccc",
          borderRadius: "8px",
          padding: "10px 14px",
          fontSize: "14px",
          color: "#333",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        {/* Header */}
        <div
          style={{
            borderBottom: "1px solid #ddd",
            marginBottom: "6px",
            paddingBottom: "4px",
            fontWeight: "bold",
          }}
        >
          {label}
        </div>

        {/* Payload values */}
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {payload.map((item, idx) => {
            const value = item.value;
            return (
              <li
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "4px",
                }}
              >
                {/* Color dot */}
                <div
                  style={{
                    width: 10,
                    height: 10,
                    backgroundColor: severityColors[value],
                    marginRight: 8,
                    borderRadius: "50%",
                  }}
                />
                {/* Bar name */}
                <span style={{ color: "#555", marginRight: 4 }}>
                  {item.name}:
                </span>
                {/* Convert value → severity label */}
                <span style={{ fontWeight: "bold", color: "#000" }}>
                  {severityLabels[item.value] || item.value}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  return null;
}
